<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <sequential-entrance from-top>
      <v-row>
        <v-col>
          <base-material-card
            color="primary"
            icon="mdi-account-circle"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Safe Keys for {{ sitedetails.idnum }}
              </div>
            </template>
            <v-data-table
              :headers="headers"
              :items="getkeyfobs"
              :search="search"
              sort-by="username"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Unit Keys</v-toolbar-title>

                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />

                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />

                  <v-spacer />
                  <v-dialog
                    v-model="dialog"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="warning"
                        dark
                        class="mb-2"
                        to="/PaythingsSecurityActions"
                      >
                        Return
                      </v-btn>
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2 mr-4"
                        @click="sync_batch"
                      >
                        Sync All
                      </v-btn>
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2 mr-4"
                        v-on="on"
                      >
                        New Key FOB
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="editedItem.username"
                                label="User Name"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="editedItem.keyfob"
                                label="FOB ID"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          :disabled="!formIsValid"
                          text
                          @click="save"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-icon
                  color="black"
                  size="20"
                  class="ma-4"
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:no-data>
                Sorry, No Keys to display for {{ sitedetails.idnum }}, but they may not be in the back office currently
              </template>
            </v-data-table>
          </base-material-card>

          <div class="py-3" />
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  const axios = require('axios')
  var numeral = require('numeral')

  export default {
    name: 'Depositusersbysite',
    props: ['id'],
    data: () => ({
      dialog: false,
      sitedetails: '',
      snackbar: false,
      search: '',
      timeout: 5000,
      alertmessage: '',
      headers: [
        { text: 'Timestamp', align: 'center', value: 'time' },
        { text: 'Safe ID', align: 'center', value: 'safeid' },
        { text: 'Keyfob', align: 'center', value: 'keyfob' },
        { text: 'Email', align: 'center', value: 'email' },
        { text: 'Actions', align: 'center', value: 'action', sortable: false },
      ],
      alerts: [],
      depositusers: [],
      editedIndex: -1,
      editedItem: {
        username: '',
        keyfob: '',
        email: ''
      },
      defaultItem: {
        username: '',
        keyfob: '',
        email: ''
      },
    }),

    computed: {
      formIsValid () {
        return this.editedItem.keyfob !== '' &&
          this.editedItem.username !== ''
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Key' : 'Edit Key'
      },
      getalerts () {
        this.alerts = this.$store.getters.alerts
        return this.alerts
      },
      getkeyfobs () {
        this.depositusers = this.$store.getters.getSafeFobs
        return this.depositusers
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.id = this.$route.params.id
      this.getsitemap(this.id)
      this.$log.debug('LOADING THIS ID ', this.id)
      this.$store.dispatch('loadSafeFobs', this.id)
      this.initialize()
    },

    methods: {
      initialize () {
        this.alerts = this.$store.getters.alerts
        this.depositusers = this.$store.getters.getSafeFobs
      },
      getsitemap (machineid) {
        console.log('get site data for ', machineid)
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          // this.$log.debug(`${key}: ${value}`)
          if (value.siteunitsprofile) {
            if (value.siteunitsprofile[0].crypto_idnum === machineid) {
              this.$log.debug(value)
              this.sitedetails = this.$store.getters.loadedSites.find(location => value.idnum === location.idnum)
            }
          }
        }
      },
      editItem (item) {
        this.editedIndex = this.depositusers.indexOf(item)
        this.$log.debug('edited index is ', this.editedIndex, 'edited item was ', item, 'alerts array is ', this.depositusers)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.depositusers.indexOf(item)
        this.$log.debug('site info is ', item)
        const MIN_KEYS = 1
        if (this.depositusers.length === MIN_KEYS) {
          this.alertmessage = 'One key must remain at a minimum'
          this.snackbar = true
        }
        if (confirm('Are you sure you want to delete this item?') && this.depositusers.splice(index, 1)) {
          this.$log.debug('site info is ', item.key)
          let rec = {
            key: item.key,
            siteid: this.sitedetails.idnum
          }
          this.$store.dispatch('removeSafeKey', rec)
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      sync_batch () {
        let allusers = this.$store.getters.getSafeFobs
        let serverpayload = []
        allusers.forEach(entry => {
          console.log(entry)
          let rec = {
            safeid: this.id,
            siteid: this.sitename,
            username: entry.username,
            usertype: entry.usertype,
            userpin: entry.accesscode
          }
          serverpayload.push(rec)
        })
        this.$store.dispatch('syncsafekeysbatch', serverpayload)
      },
      save () {
        // check unique fob id
        // check format
        // check for not allowed chars

        this.$log.debug('EDITED INDEX WAS ', this.editedIndex)
        const user = {
          siteid: this.sitedetails.idnum,
          username: this.editedItem.username.trim(),
          keyfob: this.editedItem.keyfob.trim(),
          key: this.editedItem.key
        }
        if (this.editedIndex > -1) {
          // let userrec = {
          //   safeid: this.id,
          //   username: user.username,
          //   userpin: user.accesscode,
          //   usertype: user.usertype
          // }
          // Object.assign(this.depositusers[this.editedIndex], this.editedItem)
          // this.$log.debug('CALLING UPDATE IN VIEW ')
          // this.$store.dispatch('updatesafefob', user)
          // there is no update, only add/remove
          this.close()
        } else {
          this.depositusers.push(this.editedItem)
          this.$store.dispatch('createSafeFob', user)
          // we add this to mqtt here also
          let userrec = {
            safeid: this.id,
            username: user.username,
            keyfob: user.keyfob,
            sitekey: this.sitedetails.sitekey
          }
          this.$store.dispatch('sendaddkeyfob', userrec)
          this.$store.dispatch('loadSafeFobs', this.id)
          this.depositusers = this.$store.getters.getSafeFobs
          this.close()
        }
        this.close()
      },
    },
  }
</script>
